/**
 * ## Calendar component
 *
 * @module src/components/calendar
 */

"use strict";

const conf = require("../../config");
const moment = require("moment-timezone");
const availability = require("../../common").availability;
const l = require("../../common").localization;

/**
 * Calendar display.
 */
const create = (options, data, callback) => {
  const target_id = options.target_id;
  const startDate = options.startDate;
  let matrix;
  if (options.hasOwnProperty("kd") && options.kd) {
    matrix = availability.byMonth(options.kd, startDate);
  }
  const date = moment(startDate).format("DD");
  const today = moment().format("DD");
  const currentMonth = moment().format("MM");
  const currentYear = moment().format("YYYY");
  const month = moment(startDate).format("MM");
  const monthName = l.translate(moment(startDate).format("MMMM"));
  const year = moment(startDate).format("YYYY");
  const dayOfStart = moment(startDate).startOf("month").day();
  const daysInMonth = moment(startDate).daysInMonth();
  const startOfMonth = moment(startDate).startOf("month").format("X");

  let thisHTML = '<div class="calendarShell">';
  thisHTML += `<div class="arrow_left" id="calendar_arrow_left_${target_id}">\
        <i class="fa fa-arrow-left"></i></div>`;
  thisHTML += `<div class="calendar_header">${monthName} ${year}</div>`;
  thisHTML += `<div class="arrow_right" id="calendar_arrow_right_${target_id}">\
        <i class="fa fa-arrow-right"></i></div>`;
  for (let i = 0; i < conf.vars.day.length; ++i) {
    thisHTML += `<div class="calendar_date_label">${l.translate(
      conf.vars.day[i]
    )}</div>`;
  }
  for (let i = 0; i < dayOfStart; ++i) {
    thisHTML += '<div class="calendar_date_blank"></div>';
  }
  for (let i = 1; i <= daysInMonth; ++i) {
    const fi = `0${i}`.slice(-2);
    const day = moment(`${year}-${month}-${fi}`).startOf("day").format("X");
    let split = 0;
    if (options.hasOwnProperty("kd") && options.kd) {
      const tmatrix = matrix[day];
      if (tmatrix.total > 0) {
        split = 100 - Math.ceil((tmatrix.claimed / tmatrix.total) * 100);
      }
    } else {
      split = 100;
    }
    if (split < 0) {
      split = 0;
    }
    let level = `style="background: rgba(19,19,19,1); \
            background: linear-gradient(to bottom, rgba(39,39,39,1) 0%, rgba(35,35,35,1) \
            ${split}%, rgba(76,76,76,1) ${split}%, rgba(76,76,76,1) 100%);"`;
    if (split === 0) {
      level = 'style="background: #5b0000;"';
    }
    if (i == today && currentMonth == month) {
      thisHTML += `<div class="calendarDateToday calenderControl${target_id}" \
                id="calendarID${i}${target_id}" data-date="${year}-${month}-${fi}" \
                ${level}>${i}</div>`;
    } else if (options.hasOwnProperty("allowPast") && options.allowPast) {
      thisHTML += `<div class="calendarDate calenderControl${target_id}" \
                id="calendarID${i}${target_id}" data-date="${year}-${month}-${fi}" \
                ${level}>${i}</div>`;
    } else if (
      currentYear > year ||
      (currentYear === year && currentMonth > month) ||
      (currentYear === year && currentMonth === month && i < today)
    ) {
      thisHTML += `<div class="calendarDatePast calenderPast${target_id}" \
                id="calendarID${i}${target_id}" data-date="${year}-${month}-${fi}" \
                ${level}>${i}</div>`;
    } else {
      thisHTML += `<div class="calendarDate calenderControl${target_id}" \
                id="calendarID${i}${target_id}" data-date="${year}-${month}-${fi}" \
                ${level}>${i}</div>`;
    }
  }
  thisHTML += '</div><div class="clear"></div>';
  $(`#${target_id}`).html(thisHTML);
  $(`#calendar_arrow_left_${target_id}`).off();
  $(`#calendar_arrow_left_${target_id}`).fastClick((e) => {
    e.stopPropagation();
    let tMonth = parseInt(month, 10) - 1;
    let tYear = year;
    if (tMonth === 0) {
      tMonth = 12;
      tYear = parseInt(year, 10) - 1;
    }
    const opt = {
      target_id,
      allowPast: options.allowPast,
      startDate:
        parseInt(
          moment(`01-${tMonth}-${tYear}`, "DD-MM-YYYY").format("X"),
          10
        ) * 1000,
      kd: options.kd,
      static: options.static,
    };
    create(opt, data, callback);
  });
  $(`#calendar_arrow_right_${target_id}`).off();
  $(`#calendar_arrow_right_${target_id}`).fastClick((e) => {
    e.stopPropagation();
    let tMonth = parseInt(month, 10) + 1;
    let tYear = year;
    if (tMonth === 13) {
      tMonth = 1;
      tYear = parseInt(year, 10) + 1;
    }
    const opt = {
      target_id,
      allowPast: options.allowPast,
      startDate:
        parseInt(
          moment(`01-${tMonth}-${tYear}`, "DD-MM-YYYY").format("X"),
          10
        ) * 1000,
      kd: options.kd,
      static: options.static,
    };
    create(opt, data, callback);
  });

  $(`.calenderControl${target_id}`).off();
  $(`.calenderControl${target_id}`).fastClick((e) => {
    e.stopPropagation();
    callback(null, {
      date: $(`#${e.target.id}`).data("date"),
      target_id: e.target.id,
    });
    $(".calendarDate").css("border", "1px solid #222");
    $(`#${e.target.id}`).css("border", "2px solid #ffffcc");
    $(".calendarDateToday").css("border", "2px solid #ffffff");
    if (options.hasOwnProperty("nodestroy") && options.nodestroy) {
      // don't destroy component
    } else {
      destroy();
    }
  });

  $(`.calenderPast${target_id}`).off();
  $(`.calenderPast${target_id}`).fastClick((e) => {
    e.stopPropagation();
  });
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/calendar/index.js
 **/